import { Env } from '@audius/common/services'

export const env: Env = {
  AAO_ENDPOINT: 'http://audius-anti-abuse-oracle-1',
  AMPLITUDE_API_KEY: null,
  AMPLITUDE_PROXY: null,
  API_KEY: '2dc52ec9a4c31790cab6653de0c637f680faa993',
  API_URL: process.env.VITE_API_URL ?? 'http://audius-api',
  APP_NAME: 'audius-client',
  ARCHIVE_ENDPOINT: process.env.VITE_API_URL ?? 'http://audius-api',
  AUDIUS_NETWORK_CHAIN_ID: 1337,
  AUDIUS_URL: 'https://audius.co',
  BITSKI_CALLBACK_URL: 'https://audius.co/bitski-callback.html',
  BITSKI_CLIENT_ID: '7a543ec2-b55f-45d6-a5d4-0448c5a23485',
  CACHE_PRUNE_MIN: '250',
  CLAIM_DISTRIBUTION_CONTRACT_ADDRESS: null,
  CLAIMABLE_TOKEN_PDA: '7vKR1WSmyHvBmCvKPZBiN66PHZqYQbXw51SZdwtVd9Dt',
  CLAIMABLE_TOKEN_PROGRAM_ADDRESS:
    'testHKV1B56fbvop4w6f2cTGEub9dRQ2Euta5VmqdX9',
  COGNITO_KEY: 'sandbox_publishable_key_e61e1acfe63bd1760827b68d4f00245b',
  COGNITO_TEMPLATE_ID: 'flwtmp_7ZUYaBUFLeNhJw',
  ENTITY_MANAGER_ADDRESS: '0x254dffcd3277C0b1660F6d42EFbB754edaBAbC2B',
  ENVIRONMENT: 'development',
  ETH_BRIDGE_ADDRESS: null,
  ETH_NETWORK_ID: '1337',
  ETH_OWNER_WALLET: '0x855FA758c77D68a04990E992aA4dcdeF899F654A',
  ETH_PROVIDER_URL: 'http://audius-eth-ganache-1',
  ETH_REGISTRY_ADDRESS: '0xABbfF712977dB51f9f212B85e8A4904c818C2b63',
  ETH_TOKEN_ADDRESS: '0xdcB2fC9469808630DD0744b0adf97C0003fC29B2',
  ETH_TOKEN_BRIDGE_ADDRESS: null,
  EXPLORE_CONTENT_URL:
    'https://download.audius.co/static-resources/explore-content.json',
  FCM_PUSH_PUBLIC_KEY: null,
  FINGERPRINT_ENDPOINT: null,
  FINGERPRINT_PUBLIC_API_KEY: null,
  GA_HOSTNAME: 'audius.co',
  GA_MEASUREMENT_ID: 'G-XXXXX',
  HCAPTCHA_BASE_URL: 'https://audius.co',
  HCAPTCHA_SITE_KEY: '2abe61f1-af6e-4707-be19-a9a4146a9bea',
  IDENTITY_SERVICE: 'http://audius-identity-service-1',
  INSTAGRAM_APP_ID: '2875320099414320',
  INSTAGRAM_REDIRECT_URL: 'http://localhost:3000',
  LOOKUP_TABLE_ADDRESS: '',
  OPTIMIZELY_KEY: 'MX4fYBgANQetvmBXGpuxzF',
  STAKING_BRIDGE_PROGRAM_ID: '',
  PUBLIC_HOSTNAME: 'audius.co',
  PUBLIC_PROTOCOL: 'https:',
  BASENAME: process.env.VITE_BASENAME || '',
  REACHABILITY_URL: 'https://audius.co/204',
  RECAPTCHA_SITE_KEY: '6LfVR-0ZAAAAADFcqNM1P1IafKwQwN0E_l-gxQ9q',
  REGISTRY_ADDRESS: '0xCfEB869F69431e42cdB54A4F4f105C19C080A601',
  SAFARI_WEB_PUSH_ID: 'web.co.audius',
  SCHEME: 'audius',
  SENTRY_DSN: 'https://4b15a7a2f2e2459997408b39a0c4942c@s.audius.co/1851611',
  SOL_BRIDGE_ADDRESS: null,
  SOL_TOKEN_BRIDGE_ADDRESS: null,
  SOLANA_CLUSTER_ENDPOINT: 'http://audius-solana-test-validator-1',
  SOLANA_FEE_PAYER_ADDRESS: 'E3CfijtAJwBSHfwFEViAUd3xp7c8TBxwC1eXn1Fgxp8h',
  SOLANA_RELAY_ENDPOINT: 'http://audius-discovery-provider-1',
  SOLANA_TOKEN_PROGRAM_ADDRESS: 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
  SOLANA_WEB3_CLUSTER: 'devnet',
  SUGGESTED_FOLLOW_HANDLES: '',
  TIKTOK_APP_ID: 'awa9re2w7ec3xrn6',
  USE_HASH_ROUTING: false,
  WAUDIO_MINT_ADDRESS: '37RCjhgV1qGV2Q54EHFScdxZ22ydRMdKMtVgod47fDP3',
  WORMHOLE_ADDRESS: null,
  WORMHOLE_RPC_HOSTS: null,
  DISCORD_BOT_SERVER: 'http://localhost:8081'
}
